module.exports = __webpack_public_path__ + "img/tick-icon.16df7944.svg";